import './App.css';
import {  Route, Routes } from 'react-router-dom';
import React, { Fragment, useEffect, useState } from "react";
import Unauthorize from './pages/Unauthorize';
import { UserContext } from './Hooks/UserContext';
import Login from './pages/Login';
// import AppInsight from './AppInsight';
import { useParams } from 'react-router-dom';
import { getCookie, setCookie, getAccessToken, parseJwt } from './common';
import HomePage from "./pages/HomePage";
import Detailed from "./pages/Detailed";
import { SignOut } from './SessionDialogue/signout';
import { SessionDialogue } from './SessionDialogue/SessionDialogue';
import ProtectedRoute from "./SessionDialogue/Protected"

function App() {
  let userRole = 0;
  const [code,setCode] = useState('');
  const userInfoData = JSON.parse(getCookie('userInfo'));
    // console.log("userInfoData",userInfoData)
    // console.log("userInfoData?.msad_groups.includes(process.env.REACT_APP_SECURE_GROUP_ADMIN)",userInfoData?.groups.includes(process.env.REACT_APP_SECURE_GROUP_ADMIN))

  if (userInfoData && userInfoData?.groups.includes(process.env.REACT_APP_SECURE_GROUP_ADMIN)) {
    userRole = 1;
  }else {
    userRole = 0;
  }

  // console.log("userrole",userRole)



  return (
    <div>
    <UserContext.Provider value={{userRole,code,setCode}}>
      {((code === null || code === '') && (getCookie('userInfo') === '' || getCookie('userInfo') === null)) ?
        (
          <Routes>
            <Route path="/" exact element={<Login />}></Route>
            <Route path="/login" element={<Login />}></Route>
            <Route path="*" element={<Login />}></Route>
          </Routes>
        ) :
        (
          (userRole > 0 ?
            (
              <Fragment>
              <SessionDialogue authTokenRefreshesIn={75} idleTime={75} authTokenExpiresIn={80} />

              <Routes>
                <Route path="/login" element={<Login />}></Route>

                 <Route path="/signout" element={<SignOut />} />

                  <Route
                    element={<ProtectedRoute requiredUserRole={userRole} />}
                  >
                    <Route path="/" element={<HomePage />} />
                    <Route path="/detail" element={<Detailed />} />
                  </Route>
                  <Route path="*" element={<Unauthorize />} />

              </Routes>
              </Fragment>
            ) :
            (<Routes>
              <Route exact path="*" element={<Unauthorize />} />
            </Routes>)
          ))

      }
    </UserContext.Provider>
    </div>
  );
}
export default App;

